import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51bd2196"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-enterprise" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title f-size-24 f-col-white08" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "descriptions-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系人：", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "descriptions-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系电话：", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "descriptions-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "污染源名称：", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "descriptions-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "社会信用服务码：", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "descriptions-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "许可证号：", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "descriptions-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "受纳水体：", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "descriptions-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "企业规模：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "descriptions-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "详细地址：", -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "descriptions-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "组织机构代码：", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = {
  key: 0,
  class: "descriptions-item video"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "content right"
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "select" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "排口：", -1))
const _hoisted_39 = { class: "select" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "监测因子：", -1))
const _hoisted_41 = { class: "row select" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "时间：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, "--", -1))
const _hoisted_44 = { class: "row point" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "超标因子及百分比：", -1))
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "echart" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { key: 0 }

import { toRefs, nextTick, getCurrentInstance, onMounted, onBeforeUnmount, ref, markRaw } from 'vue'
import * as echarts from 'echarts'
import Video from 'video.js'
import { Api } from '@/api/publicApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogEnterprise',
  props: {
  data: Object,
},
  setup(__props) {

const api = new Api()
const props = __props

const active = ref(null)

const videoContainer = ref()
const video = ref()
const videoList: any = ref([])
let customInterval = null
let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}


const myChart = ref<any>(null)
const enterpriseChart = ref<any>(null)
const { data } = toRefs(props)
const selectEchart = ref('时均值')
const cbyz = ref('无')
// const { proxy } = getCurrentInstance()
let instance: any = null
const show = ref(false)
const testX = [
  '2022-01-25 05',
  '2022-01-25 06',
  '2022-01-25 07',
  '2022-01-25 08',
  '2022-01-25 09',
  '2022-01-25 10',
  '2022-01-25 11',
  '2022-01-25 12',
]
const testY = [0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4]
const initChart = (xdata = testX, ydata = testY) => {
  // const dom = document.getElementById('echart-enterprise')
  // console.log("dom 结构",dom)
  if (myChart.value) {
    myChart.value.clear()
  }
  // instance = proxy.$echarts.init(dom)

  const charts = {
    unit: '',
    lineX: xdata,
    value: ydata,
  }
  const option = {
    title: {
      show: false,
    },
    tooltip: {
      trigger: 'item',
    },
    grid: {
      left: '0%',
      right: '12%',
      bottom: '0%',
      top: '10%',
      containLabel: true,
    },
    xAxis: {
      name: '时间',
      data: xdata,
      nameTextStyle: {
        fontSize: 12,
      },
      boundaryGap: false,
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#BAE7FF',
        },
      },

      axisLabel: {
        type: 'category',
        formatter: '{value}',
        margin: 20,
        textStyle: {
          fontSize: 12,
          color: '#8EC0CE',
        },
      },
    },
    yAxis: {
      show: true,
      type: 'value',
      min: 0,
      max: 1,
      splitLine: {
        show: true,
        lineStyle: {
          width: 2,
          dashOffset: 10,
          type: 'dashed',
          color: 'rgba(230, 247, 255, 0.2)',
        },
      },
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          fontSize: 14,
          color: '#8EC0CE',
        },
      },
    },
    dataZoom: [
      {
        type: 'inside',
        start: 10,
        end: 100,
      },
    ],
    series: [
      {
        name: '',
        type: 'line',
        color: '#09CEA5',
        smooth: false, // 关键点，为true是不支持虚线，实线就用true
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2,
              type: 'dotted', // 'dotted'虚线 'solid'实线
            },
          },
        },
        lineWidth: 6,
        symbol: '',
        symbolSize: 12,
        markLine: {
          // 标准线
          symbol: 'triangle',
          symbolSize: 12,
          symbolOffset: [0, [0, -10]],
          silent: true,
          lineStyle: {
            color: '#FFD225',
            width: 2,
          },
          label: {
            color: '#FFD225',
            fontSize: 14,
          },
          data: [
            {
              yAxis: 0.8,
              label: {
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            }, // 最大值水平线或垂直线
          ],
        },
        data: ydata,
      },
    ],
  }
}

const changeVideo = (deviceId) => {
  nextTick(() => {
    api.screen.getCameraStreamListByIdUsingPost({
      id: deviceId,
    })
      .then((res) => {
        let url = ''
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].deviceId === deviceId) {
            url = res.data[i].videoStream
            break
          }
        }
        player.src({
          type: '',
          src: url,
        })
        player.play()
      })
  })
}
onMounted(() => {
  console.log("啊啊啊", enterpriseChart.value)
  if (enterpriseChart.value) {
    myChart.value = markRaw(echarts.init(enterpriseChart.value));
  }
  if (player) {
    player.dispose()
  }
  videoList.value = []
  if (data.value.videoPoints && data.value.videoPoints.length > 0) {
    active.value = data.value.videoPoints[0].videoDeviceCode
    for (let i = 0; i < data.value.videoPoints.length; i++) {
      videoList.value.push(
        {
          label: data.value.videoPoints[i].videoDeviceName,
          value: data.value.videoPoints[i].videoDeviceCode
        },
      )
    }
    nextTick(() => {
      const video = document.createElement('video');
      video.setAttribute('style', 'width: 100%; height: 100%');
      video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
      video.setAttribute('id', 'pop_video');
      videoContainer.value.appendChild(video);
      setTimeout(() => {
        const option = {
          muted: false,
          controls: true,
          loop: false,
          autoplay: false,
          sources: [],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          // poster:,
          // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
        }
        // 初始化的时候标签默认都是显示的
        player = Video('pop_video', option, () => {
          player.on('error', () => {
            player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
            console.log('视频加载错误')
          })
        })
        changeVideo(videoList.value[0].value)
      }, 1000)
    })
  }
})

onBeforeUnmount(async () => {
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})

return (_ctx: any,_cache: any) => {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_time_picker = _resolveComponent("n-time-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).wrymc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["content left", show.value ? '' : 'info'])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(data).lxrxm || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(data).lxrdh || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(data).wrymc || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(data).tyshxydm || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(data).pwxkzdm || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data).snst || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(data).qygm || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(data).xxd || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(data).zzkgdm || '-'), 1)
        ]),
        (show.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
          : _createCommentVNode("", true)
      ], 2),
      (show.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_n_select, {
                  value: _ctx.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                  size: "small",
                  options: _ctx.options
                }, null, 8, ["value", "options"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_n_select, {
                  value: _ctx.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                  size: "small",
                  options: _ctx.options
                }, null, 8, ["value", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createVNode(_component_n_time_picker, {
                value: _ctx.timestamp,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timestamp) = $event)),
                size: "small"
              }, null, 8, ["value"]),
              _hoisted_43,
              _createVNode(_component_n_time_picker, {
                value: _ctx.timestamp,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.timestamp) = $event)),
                size: "small"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, _toDisplayString(cbyz.value), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", {
                  class: _normalizeClass(["echart-btn", { active: selectEchart.value === '时均值' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.select('时均值')))
                }, " 时均值 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["echart-btn", { active: selectEchart.value === '日均值' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.select('日均值')))
                }, " 日均值 ", 2)
              ]),
              _createElementVNode("div", {
                id: "echart-enterprise",
                class: "echart-dom",
                ref_key: "enterpriseChart",
                ref: enterpriseChart
              }, null, 512)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (videoList.value && videoList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          (videoList.value)
            ? (_openBlock(), _createBlock(_component_n_select, {
                key: 0,
                style: {"width":"200px","margin-bottom":"10px"},
                value: active.value,
                "onUpdate:value": [
                  _cache[6] || (_cache[6] = ($event: any) => ((active).value = $event)),
                  changeVideo
                ],
                size: "small",
                options: videoList.value
              }, null, 8, ["value", "options"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref_key: "videoContainer",
            ref: videoContainer,
            class: "video-box"
          }, null, 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})